import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Error Boundary to catch and display errors instead of white screen
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error("React Error Boundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '40px', 
          fontFamily: 'system-ui, sans-serif',
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          <h1 style={{ color: '#dc2626', marginBottom: '20px' }}>
            Ein Fehler ist aufgetreten
          </h1>
          <p style={{ marginBottom: '20px' }}>
            Die Anwendung konnte nicht geladen werden. Bitte versuchen Sie:
          </p>
          <ul style={{ marginBottom: '20px', lineHeight: '1.8' }}>
            <li>Die Seite neu zu laden (Strg+Shift+R)</li>
            <li>Den Browser-Cache zu leeren</li>
            <li>Die Seite im Inkognito-Modus zu öffnen</li>
          </ul>
          {this.state.error && (
            <details style={{ 
              background: '#fef2f2', 
              padding: '15px', 
              borderRadius: '8px',
              marginTop: '20px'
            }}>
              <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                Technische Details
              </summary>
              <pre style={{ 
                marginTop: '10px', 
                whiteSpace: 'pre-wrap', 
                fontSize: '12px',
                overflow: 'auto'
              }}>
                {this.state.error.toString()}
                {this.state.errorInfo?.componentStack}
              </pre>
            </details>
          )}
          <button 
            onClick={() => window.location.reload()} 
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              background: '#2563eb',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Seite neu laden
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
